var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HDSButton } from "@here/hds-react-components/Button";
import { HDSIcon } from "@here/hds-react-components/Icon";
import { ANNOTATION_ENTRY_MODAL } from "../constants";
export var ConfirmEntryBody = function (props) {
    var setShowEntryModal = props.setShowEntryModal, onFloorPlansOnlyClick = props.onFloorPlansOnlyClick;
    var handleFloorPlansOnlyClick = function () {
        onFloorPlansOnlyClick && onFloorPlansOnlyClick(true);
    };
    var handleAnnotationClick = function () {
        setShowEntryModal(false);
        onFloorPlansOnlyClick && onFloorPlansOnlyClick(false);
    };
    return (_jsxs("div", __assign({ className: "entryScreen" }, { children: [_jsxs("div", __assign({ className: "entryScreenTxt" }, { children: [_jsx("p", { children: ANNOTATION_ENTRY_MODAL.UPLOAD_FLOOR_PLANS }), _jsx(HDSButton, __assign({ className: "entryScreenBtn", "data-testid": "uploadFloorPlanBtn", size: "small", width: "32px", onClick: handleFloorPlansOnlyClick }, { children: _jsx(HDSIcon, { name: "chevron-right" }) }))] })), _jsxs("div", __assign({ className: "entryScreenTxt" }, { children: [_jsx("p", { children: ANNOTATION_ENTRY_MODAL.COMMENT_ON_MAP }), _jsx(HDSButton, __assign({ className: "entryScreenBtn", "data-testid": "startAnnotationBtn", size: "small", width: "32px", onClick: handleAnnotationClick }, { children: _jsx(HDSIcon, { name: "chevron-right" }) }))] }))] })));
};
